<template>
    <div>
        <b-container class="text-center">
        <b-row>
            <b-col md="3 mr-2 mb-2"  v-show="cz10_appagenda">
                <b-link :to="{name: 'Agenda'}" class="text-white">
                    <p class="h1 border rounded pb-3 pt-3 bg-primary ">
                        <b-icon icon="calendar3" aria-hidden="true"></b-icon><br>
                        Agenda
                    </p>
                </b-link>
            </b-col>
            <b-col md="3 mr-2 mb-2"  v-show="cz10_apppacientes">
                <p class="h1 border rounded pb-3 pt-3 bg-primary">
                    <b-link :to="{ name: 'Pacientes'}" class="text-white">
                        <b-icon icon="people" aria-hidden="true"></b-icon><br>
                        Pacientes
                    </b-link>
                </p>
            </b-col>
            <b-col md="3 mr-2 mb-2" v-show="cz10_appemergencia">
                <p class="h1 border rounded pb-3 pt-3 bg-primary">
                    <b-link :to="{ name: 'Listareforco'}" class="text-white">
                        <b-icon icon="people" aria-hidden="true"></b-icon><br>
                        Emergência
                    </b-link>
                </p>
            </b-col>
            <b-col md="3 mr-2 mb-2"  v-show="cz10_appdashboard">
                <p class="h1 border rounded pb-3 pt-3 bg-primary">
                    <b-link :to="{ name: 'Listafinanceiro'}" class="text-white">
                        <b-icon icon="graph-up" aria-hidden="true"></b-icon><br>
                        Dashboard
                    </b-link>
                </p>
            </b-col>
            <b-col md="3 mr-2 mb-2"  v-show="cz10_apppainel">
                <p class="h1 border rounded pb-3 pt-3 bg-primary">
                    <b-link :to="{ name: 'Painel'}" class="text-white">
                        <b-icon icon="card-checklist" aria-hidden="true"></b-icon><br>
                        Painel
                    </b-link>
                </p>
            </b-col>
        </b-row>
        </b-container>
    </div>
</template>

<script>
export default {
  name: 'home',
  mounted () {
    this.$emit('is-not-login')
  },
  created () {
    const obj = JSON.parse(localStorage.usuarioMC)
    this.mostra = false
    this.cz10_appagenda = false
    this.cz10_appdashboard = false
    this.cz10_appemergencia = false
    this.cz10_apppacientes = false
    this.cz10_apppainel = false
    if (obj.usuario.cz10_appagenda === 'S') {
      this.cz10_appagenda = true
    }
    if (obj.usuario.cz10_appdashboard === 'S') {
      this.cz10_appdashboard = true
    }
    if (obj.usuario.cz10_appemergencia === 'S') {
      this.cz10_appemergencia = true
    }
    if (obj.usuario.cz10_apppacientes === 'S') {
      this.cz10_apppacientes = true
    }
    if (obj.usuario.cz10_apppainel === 'S') {
      this.cz10_apppainel = true
    }
  },
  data () {
    return {
      active: 'home',
      activeSidebar: false,
      mostra: false
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue